import "./App.css";
import { Routes, Route } from "react-router-dom";

import Home           from "./pages/Home";
import Experience     from "./pages/Experience";
import Skills         from "./pages/Skills";
import Projects       from "./pages/Projects";
import WhoAmI         from "./pages/WhoAmI";
import ProjectDisplay from "./pages/ProjectDisplay";
import Blogs          from "./pages/Blogs";
import BlogPost       from "./pages/BlogPost";
import Services       from "./pages/Services";
import Navbar         from "./components/Navbar";
import Footer         from "./components/Footer";
import AdminLogin     from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ScrollToTopButton from "./components/ScrollToTopButton";
import CustomCursor from "./components/CustomCursor";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/"                element={<Home />}           />
        <Route path="/whoami"          element={<WhoAmI />}         />
        <Route path="/projects"        element={<Projects />}       />
        <Route path="/project/:id"     element={<ProjectDisplay />} />
        <Route path="/experience"      element={<Experience />}     />
        <Route path="/skills"          element={<Skills />}         />
        <Route path="/services"        element={<Services />}       />
        <Route path="/blogs"           element={<Blogs />}          />
        <Route path="/blogs/:id"       element={<BlogPost />}       />
        <Route path="/admin/login"     element={<AdminLogin />}     />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      <Footer />
      <ScrollToTopButton />
      <CustomCursor />
    </div>
    
  );
}

export default App;